import { CMSMenuPanel } from './CMSMenuPanel';

export default CMSMenuPanel;
